export default {
  gift_card_removed: 'Card cadou eliminat',
  invalid_gift_card: 'Cardul cadou este invalid',
  gift_card_applied: 'Card cadou aplicat',
};
